import { z } from "zod";

export const loginSchema = z.object({
  email: z.string().email(),
  password: z.string().min(8, {
    message: "Password should be longer than 8 character",
  }),
});

export const registerSchema = z
  .object({
    firstName: z.string().min(2, {
      message: "First name should be longer than 2 characters",
    }),
    lastName: z.string().min(1, {
      message: "Last name should be longer than 1 character",
    }),
    instituteName: z.string().min(2, {
      message: "Institution name should be longer than 2 characters",
    }),
    email: z.string().email({
      message: "Invalid email address",
    }),
    password: z.string().min(8, {
      message: "Password should be longer than 8 character",
    }),
    confirmPassword: z.string().min(8, {
      message: "Password should be longer than 8 character",
    }),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords don't match",
    path: ["confirmPassword"],
  });
